module.exports = __webpack_public_path__ + "img/Zugführer_Löschzug.f77d2360.svg";